module.exports = __webpack_public_path__ + "img/forecast-icon.e22a77f9.svg";